import { eventBus } from '@/utils/eventBus'

export default {
  install(VueInstance, options) {
    VueInstance.prototype.$eventBus = eventBus
  },
}
